var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.17871C14.2164 2.17871 16.3421 3.05919 17.9094 4.62646C19.4767 6.19373 20.3571 8.3194 20.3571 10.5359C20.3571 14.0673 17.8757 17.9159 12.9771 22.1227C12.7048 22.3567 12.3575 22.4852 11.9984 22.4849C11.6393 22.4846 11.2923 22.3555 11.0203 22.121L10.6963 21.8399C6.01457 17.7427 3.64285 13.9884 3.64285 10.5359C3.64285 8.3194 4.52334 6.19373 6.0906 4.62646C7.65787 3.05919 9.78354 2.17871 12 2.17871ZM12 7.32157C11.1475 7.32157 10.3299 7.66021 9.72715 8.26301C9.12436 8.86581 8.78571 9.68337 8.78571 10.5359C8.78571 11.3883 9.12436 12.2059 9.72715 12.8087C10.3299 13.4115 11.1475 13.7501 12 13.7501C12.8525 13.7501 13.67 13.4115 14.2728 12.8087C14.8756 12.2059 15.2143 11.3883 15.2143 10.5359C15.2143 9.68337 14.8756 8.86581 14.2728 8.26301C13.67 7.66021 12.8525 7.32157 12 7.32157Z",
    fill: "#F0BA0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.cf479416797b954f887fbbb0d02be89d.svg";
export { ForwardRef as ReactComponent };